module.exports = __webpack_public_path__ + "img/stripe.eff97f28.png";